// Field names
export const TARGET_SHOPPER_ID = 'targetShopperId';
export const TARGET_TENANT_ID = 'targetTenantId';
export const TARGET_EMAIL_ADDRESS = 'targetEmailAddress';
export const SOURCE_ORDER_NUMBER = 'sourceOrderNumber';

// Field types
export const INPUT_FIELD = 'input';
export const DROPDOWN_FIELD = 'dropdown';
